export default __webpack_public_path__ + "static/Travelling-beyond-your-balcony-142e255079da0c16fff8476a64ee0218.jpg";